import gql from 'graphql-tag';
import { basicMemberFields } from './GetMember';
import { storeBasicFields } from './GetStore';

const key = `CreateMember`;
const mutation = gql`
mutation ${key}($input:CreateMemberInput!) {
  createMember(input: $input) {
    ${basicMemberFields}
    store {
      ${storeBasicFields}
    }
    role {
      id
    }
    manager {
      ${basicMemberFields}
    }
  }
}
`;

export const CREATE_MEMBER = { key, mutation };
